import { roundWith2Decimal } from './roundWith2Decimal';

export const roundForSurfacesInputs = (value: number): number => {
  return roundWith2Decimal(value);
};
